import React from 'react'
import JoinUsPage from '../parts/pages/JoinUsPage'

export default function JoinUs() {
  return <JoinUsPage />
}
